// extracted by mini-css-extract-plugin
export default {"header":"MainHeader_header__LLCp4","active":"MainHeader_active__AFxse"};